import { FC } from "react";
import { useField } from 'formik';
import { IBaseField } from "./BaseField";
import { CheckBox } from "src/UI";

interface ICheckBoxFieldProps extends IBaseField {
	setData: Function;
	defaultValue?: any;
	inline?: boolean;
}

/**
 * Текстовое поле
 */
const CheckBoxField: FC<ICheckBoxFieldProps> = ( props ) => {

	const { name, setData, ...otherProps } = props;
	const [ inputProps, , helpers ] = useField( name );

	const onChangeValueHandler = ( value: boolean ) => {
		helpers.setTouched( true );
		helpers.setValue( value, true );
		!!setData && setData((data: any) => {
			return { ...data, [name]: value }
		});
	};

	return (
		<CheckBox
			{...inputProps}
			{...otherProps}
			onChangeValue={onChangeValueHandler}
			label={otherProps.title}
		/>
	);
};

export default CheckBoxField;
